import { useSelector, useDispatch } from 'react-redux';
import useLocalStore from '../../../../hooks/useLocalStore';
import { setSliceIsDraggingFileAction } from '../../../../redux/slices/FJSliceCommon';
import FJImageExtenderRight from '../view/FJImageExtenderRight';
import FJActionImageExtender from '../../../../redux/action/FJActionImageExtender';

const FJImageExtenderRightContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();

    const headerTabIndex = useSelector(state => state.common.headerTabIndex);
    const taskStatus = useSelector(state => state.common.taskStatus);

    const _setIsDraggingFile = value => {
        dispatch(setSliceIsDraggingFileAction(value));
    };

    const uploadImg = file => {
        dispatch(FJActionImageExtender.uploadImageAction(file));
    };

    return (
        <FJImageExtenderRight
            headerTabIndex={headerTabIndex}
            setIsDraggingFile={_setIsDraggingFile}
            uploadImg={uploadImg}
            taskStatus={taskStatus}
        />
    );
};

export default FJImageExtenderRightContainer;
